let tooltipEl = null;

function createTooltip() {
    if (tooltipEl) return;
    tooltipEl = document.createElement('div');
    tooltipEl.className = 'v-tooltip';
    tooltipEl.style.position = 'fixed';
    tooltipEl.style.zIndex = '2147483647';
    tooltipEl.style.pointerEvents = 'none';
    tooltipEl.style.opacity = '0';
    tooltipEl.style.transition = 'opacity 0.25s ease';
    tooltipEl.style.maxWidth = '250px';
    tooltipEl.style.wordBreak = 'break-word';
    document.body.appendChild(tooltipEl);
}

function showTooltip(el, value, modifiers) {
    createTooltip();

    if (!value) return;
    if (value.onlyOverflow) {
        if (el.scrollWidth <= el.clientWidth) return;
    }

    let text = '';
    if (typeof value === 'string') text = value;
    else text = value.text || '';

    tooltipEl.textContent = text;

    const rect = el.getBoundingClientRect();
    let top = rect.top - tooltipEl.offsetHeight - 8;
    let left = rect.left + rect.width / 2 - tooltipEl.offsetWidth / 2;
    let transform = '';

    const placement = value?.theme?.placement || 'top';
    switch (placement) {
        case 'bottom':
            top = rect.bottom + 8;
            transform = 'translateX(-50%)';
            break;
        case 'left':
            left = rect.left - tooltipEl.offsetWidth - 8;
            top = rect.top + rect.height / 2 - tooltipEl.offsetHeight / 2;
            transform = '';
            break;
        case 'right':
            left = rect.right + 8;
            top = rect.top + rect.height / 2 - tooltipEl.offsetHeight / 2;
            transform = '';
            break;
        default:
            transform = 'translateX(-50%)';
            break;
    }

    tooltipEl.style.top = `${top}px`;
    tooltipEl.style.left = `${left}px`;
    tooltipEl.style.transform = transform;

    if (value?.theme) {
        Object.entries(value.theme).forEach(([key, val]) => {
            switch (key) {
                case 'backgroundColor':
                    tooltipEl.style.backgroundColor = val;
                    break;
                case 'color':
                    tooltipEl.style.color = val;
                    break;
                case 'padding':
                    tooltipEl.style.padding = val;
                    break;
                case 'fontSize':
                    tooltipEl.style.fontSize = val;
                    break;
                case 'borderRadius':
                    tooltipEl.style.borderRadius = val;
                    break;
                case 'width':
                    tooltipEl.style.maxWidth = val;
                    break;
                default:
                    tooltipEl.style.setProperty(`--v-tooltip-${key}`, val);
            }
        });
    }

    tooltipEl.style.opacity = '1';
}

function hideTooltip() {
    if (!tooltipEl) return;
    tooltipEl.style.opacity = '0';
}

export default {
    mounted(el, binding) {
        const { value, modifiers } = binding;

        el.addEventListener('mouseenter', () => showTooltip(el, value, modifiers));
        el.addEventListener('mouseleave', hideTooltip);
        window.addEventListener('scroll', hideTooltip);
    },
    updated(el, binding) {
        const { value } = binding;
        if (tooltipEl) {
            tooltipEl.textContent = typeof value === 'string' ? value : value?.text || '';
        }
    },
    unmounted() {
        hideTooltip();
    },
};